import React, { Component } from 'react';

import { Grid, Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import { BackOnPrimaryIcon } from '../../components/icons';
import renderHTML from 'react-render-html';
import DrawerCustom from '../../components/DrawerCustom';
const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        cursor: 'pointer'
    },
});
function PrivacyPolicyView(props){
    const {classes, t, about_details } = props
        var    content = about_details && about_details.privacy_policy && about_details.privacy_policy.content ? about_details.privacy_policy.content : ""
        return (
            <div>
                <DrawerCustom
                    open={props.open}
                    onClose={()=>props.onCloseItem('privacy')}
                    title = {t('privacy_title')}
                    enableBack
                    children={       
                        <Grid item>
                            <Grid xs={12} item className={classes.boxItemContent}>
                            {/* {(content)} */}
                            <div dangerouslySetInnerHTML={{__html: content}}/>
                            </Grid>
                        </Grid>
                }/>


        </div>
        );
}

export default withStyles(styles)(withTranslation()(PrivacyPolicyView));